export const TOGGLE_ACCOUNT_SIDE_MENU = 'TOGGLE_ACCOUNT_SIDE_MENU';
export const TOGGLE_ACCOUNT_SIDE_MENU_ERROR_MODAL = 'TOGGLE_ACCOUNT_SIDE_MENU_ERROR_MODAL';

